import type { UpdateAgendaRecordRes, UpdateWithNestedListRes } from 'types';
import { CreateOrUpdateActionException } from 'utils/error';

type RecordResponse = UpdateAgendaRecordRes | UpdateAgendaRecordRes[] | UpdateWithNestedListRes | undefined;

export const validateMessage = (response: RecordResponse): void => {
  if (!response) {
    return;
  }

  if (Array.isArray(response)) {
    response.forEach((res) => validateMessage(res));
    return;
  }

  const mainRecordResponse = 'mainRecord' in response ? response.mainRecord : response;
  const nestedRecordsResponse = 'nestedRecords' in response ? response.nestedRecords : [];

  const { message } = mainRecordResponse;

  if (message && message.message !== 'Success') {
    throw new CreateOrUpdateActionException(message.message);
  }

  nestedRecordsResponse.forEach((record) => {
    validateMessage(record);
  });
};
